// exclude-from-index
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import InputAdornment from '@mui/material/InputAdornment';

import { IconButton, TextField } from '@mui/material';
import { VisibleIcon } from './TextInput.styles';

const StyledTextField = styled(TextField)`
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }

  .bookingSearchWidgetCon & > div > input {
    padding: 13px 14px;
  }

  .bookingSearchWidgetCon & > label {
    font-size: 0.9rem;
  }

  .propertySearchWidgetCon & > div > input {
    padding: 13px 14px;
  }

  .propertySearchWidgetCon & > label {
    font-size: 0.9rem;
  }

  .propertySearchWidgetCon & > label.Mui-focused,
  .propertySearchWidgetCon & > label[class*='MuiInputLabel-shrink'] {
    transform: translate(14px, -6px) scale(0.75) !important;
  }

  label.Mui-focused {
    color: #53b7b0;
  }

  .Mui-focused fieldset {
    border-color: #53b7b0 !important;
  }

  .MuiInput-underline:after {
    border-bottom-color: #53b7b0 !important;
  }
`;

function TextInput(props) {
  const { errorText, helperText, type, labelText, styledProps, fullWidth, name, ...defaultProps } = props;
  const { error, onFocus, InputProps, value } = defaultProps;
  const [showPassword, setShowPassword] = useState(false);
  const passwordToggle = showPassword ? 'text' : 'password';

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <StyledTextField
      variant="standard"
      {...defaultProps}
      style={{ ...styledProps }}
      type={type === 'password' ? passwordToggle : type}
      fullWidth={fullWidth}
      helperText={error ? errorText : helperText}
      onFocus={(e) => {
        if (`${value}`.length > 0) e.target.select();
        if (onFocus) onFocus(e);
      }}
      name={name}
      InputProps={{
        endAdornment: type === 'password' && (
          <InputAdornment position="end">
            <IconButton aria-label="Toggle password visibility" onClick={handleClickShowPassword} size="large">
              <VisibleIcon className={`show-${showPassword}`} />
            </IconButton>
          </InputAdornment>
        ),
        'data-testid': `text-input-${name}`,
        ...InputProps
      }}
    />
  );
}

TextInput.propTypes = {
  /**
   * Message that is displayed when the input has an error
   */
  errorText: PropTypes.string,
  /**
   * Optional helper text that sits below the input
   */
  helperText: PropTypes.string,

  type: PropTypes.string,

  labelText: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  variant: PropTypes.oneOf(['standard', 'outlined']),
  value: PropTypes.string,
  onChange: PropTypes.func,
  styledProps: PropTypes.shape({}),
  InputProps: PropTypes.shape({}),
  fullWidth: PropTypes.bool,
  autoComplete: PropTypes.string,
  placeholder: PropTypes.string,
  onFocus: PropTypes.func
};

TextInput.defaultProps = {
  errorText: 'Error',
  helperText: undefined,
  type: '',
  name: '',
  label: '',
  variant: 'standard',
  labelText: '',
  onChange: () => {},
  value: undefined,
  styledProps: {},
  InputProps: {},
  fullWidth: true,
  autoComplete: 'off',
  placeholder: '',
  onFocus: () => {}
};

export default TextInput;
